import { Extensions } from '@tiptap/react';
import { ExportDocx } from '@tiptap-pro/extension-export-docx';

import { customNodes } from './export-custom-nodes';
import { numberingFormats } from '../numbering-formats';

// PDF export builds a DOCX and posts it to Tiptap's convert endpoint itself, so
// extension-export-pdf is not registered — it only ever held the token, and it
// bundles a second copy of `docx` (~230kB gzipped).
export function createExportExtensions(): Extensions {
  return [
    ExportDocx.configure({
      customNodes,
      numberingFormats,
      onCompleteExport: () => {},
    }),
  ];
}
